import React from 'react';
import { motion } from 'framer-motion';
import Section from '../../components/ui/Section';
import GlowingPortal from '../../components/ui/GlowingPortal';
import CinematicText from '../../components/ui/CinematicText';

const NlpSection = () => {
  return (
    <Section className="bg-darker overflow-hidden border-t border-white/5 relative">
      {/* Ambient glow */}
      <div className="absolute top-1/2 left-0 w-[500px] h-[500px] -translate-y-1/2 -translate-x-1/2 bg-gold/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
        {/* Image */}
        <div className="relative group">
          <div className="absolute -inset-1 rounded-sm opacity-0 group-hover:opacity-100 transition-opacity duration-1000 pointer-events-none"
            style={{ background: 'linear-gradient(135deg, rgba(212,175,55,0.3), transparent, rgba(212,175,55,0.1))', filter: 'blur(2px)' }} />
          <motion.img
            initial={{ scale: 1.05, filter: "brightness(0.6)" }}
            whileInView={{ scale: 1, filter: "brightness(0.85)" }}
            viewport={{ once: true }}
            transition={{ duration: 1.5 }}
            src="https://media-manager-c.questera.ai/greta-media/8c84f85263efda659889de32f1f32e795be69e9a2504f254db44deecf03d5d2eaf8d8138b6c4ad97d7d004f4d5618742/images/aW1hZ2UvcG5n/276ace7e98fc392a3a18ddcb52406911.png"
            alt="Confident woman"
            className="relative z-10 w-full h-[600px] object-cover object-top rounded-sm border border-white/10 grayscale group-hover:grayscale-0 transition-all duration-1000"
          />
        </div>

        {/* Text */}
        <div>
          <div className="text-4xl md:text-5xl font-serif mb-8 text-cream">
            <CinematicText text="Ich weiß, wie es sich anfühlt, wenn Du nur noch" delay={0} className="mb-2" />
            <motion.span
              initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
              transition={{ delay: 0.8 }}
              className="italic text-wine-light"
            >
              funktionierst.
            </motion.span>
          </div>

          <div className="space-y-6 text-cream/70 font-light text-lg leading-relaxed">
            <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.3 }}>
              <GlowingPortal to="/female-leadership-fuer-frauen">Hustle-Burnout</GlowingPortal>,
              ständiges Leisten und die leise Stimme des Selbstzweifels – das alte Paradigma hat ausgedient.
              Du hast so viel erreicht, doch tief drinnen spürst Du{' '}
              <GlowingPortal to="/female-leadership-fuer-frauen">energetische Blockaden</GlowingPortal>,
              die Dich vom wahren Flow abhalten.
            </motion.p>

            <motion.blockquote
              initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: 0.5 }}
              className="text-xl text-cream font-serif italic border-l-2 border-gold pl-6 py-2 my-8"
              style={{ borderColor: '#D4AF37', boxShadow: '-4px 0 20px rgba(212,175,55,0.2)' }}
            >
              "Stell Dir vor, Du wachst morgens auf und spürst eine tiefe, unerschütterliche innere Ruhe."
            </motion.blockquote>

            <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.7 }}>
              Erfolg darf leicht sein. <GlowingPortal to="/beziehungsheilung-fuer-frauen">Beziehungen</GlowingPortal> dürfen heilen.
              Komm mit mir in Deine <GlowingPortal to="/programme"><strong>Queen-Energie</strong></GlowingPortal>.
            </motion.p>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default NlpSection;